export default __webpack_public_path__ + "static/media/技术高端人脉.ad0281f1.png";